import { VelocityInput } from "./VelocityInput";

export const ScriptedPitchView = ({
  scriptedPitch,
  currentPitch,
  onVelocityChange,
  onNoteChange,
  onSubmit,
  onReset,
  disabled,
}) => {
  if (!scriptedPitch) return null;

  return (
    <div className="space-y-3 sm:space-y-4">
      <div className="grid grid-cols-2 gap-2 sm:gap-3">
        <div className="bg-blue-50 p-2 sm:p-3 rounded-lg">
          <div className="text-xs sm:text-sm font-medium text-gray-500">
            Pitch Type
          </div>
          <div className="text-base sm:text-lg font-semibold text-gray-900 mt-0.5">
            {scriptedPitch.type}
          </div>
        </div>
        <div className="bg-blue-50 p-2 sm:p-3 rounded-lg">
          <div className="text-xs sm:text-sm font-medium text-gray-500">
            Target Zone
          </div>
          <div className="text-base sm:text-lg font-semibold text-gray-900 mt-0.5">
            {scriptedPitch.zone}
          </div>
        </div>
      </div>

      <VelocityInput
        value={currentPitch.velocity}
        onChange={onVelocityChange}
        disabled={disabled}
      />

      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">
          Notes
        </label>
        <textarea
          value={currentPitch.note || ""}
          onChange={(e) => onNoteChange(e.target.value)}
          placeholder="Optional notes about the pitch..."
          className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm
            focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
            resize-none"
          rows={2}
          disabled={disabled}
        />
      </div>

      <div className="flex gap-2 pt-1">
        <button
          type="button"
          onClick={onSubmit}
          disabled={disabled}
          className="flex-1 px-3 sm:px-4 py-1.5 sm:py-2 bg-blue-600 text-white rounded-md text-sm
                   hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Record Pitch
        </button>
        <button
          type="button"
          onClick={onReset}
          className="px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm text-gray-600 bg-gray-100 rounded-md 
                   hover:bg-gray-200"
        >
          Reset
        </button>
      </div>
    </div>
  );
};
